module.exports = __webpack_public_path__ + "img/mail.90ae0c38.svg";